import { Expose, Type } from 'class-transformer';
import { ExpenseIncomeStatusEnum } from 'common/constants/enum';

// Model

class AccountableModel {
  id: string;
  name: string;
}

export class OtherExpensesModel {
  id: string;
  number: string;
  status: ExpenseIncomeStatusEnum;
  description: string;

  @Expose({ name: 'acknowledged_at' })
  @Type(() => Date)
  acknowledgedAt: Date;

  @Expose({ name: 'account_type' })
  accountType: string;

  @Type(() => AccountableModel)
  accountable: AccountableModel;

  @Type(() => Number)
  amount: number;

  @Expose({ name: 'created_at' })
  @Type(() => Date)
  createdAt: Date;

  @Expose({ name: 'transaction_at' })
  @Type(() => Date)
  transactionAt: Date;

  @Expose({ name: 'ref_id' })
  refId: string;

  @Expose({ name: 'is_resolved' })
  isResolved: boolean;
}

// Input

export type getOtherExpenseInput = {
  id: string;
};

export type OtherExpensesMutationInput = {
  transactionAt: Date;
  amount: number;
  description: string;
  accountType: string | null;
  accountableId: string | null;
};

export type OtherExpensesCreateInput = {
  expensableRefId: string;
  expensableRefType: string;
  otherExpenses: OtherExpensesMutationInput[];
};

export type OtherExpensesUpdateInput = {
  otherExpenseRefId: string;
  body: OtherExpensesMutationInput;
};

export type OtherExpensesVoidInput = {
  otherExpenseRefId: string;
};
